var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 55.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7ba00;}.cls-2{fill:#047583;}.cls-3{fill:#014954;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.03 25.72 73.82 0 58.28 11.64 55.03 22.38 66.03 25.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.19,
    y: 26.27,
    width: 13.85,
    height: 11.49,
    transform: "translate(10.62 78.35) rotate(-73.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.2 41.64 58.22 51.48 46.21 51.48 50.2 38.31 61.2 41.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.66 51.48 42.66 39.75 36.91 29.7 31.16 39.75 31.16 51.48 42.66 51.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.79 25.72 0 0 15.54 11.64 18.79 22.38 7.79 25.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.96,
    y: 25.09,
    width: 11.49,
    height: 13.85,
    transform: "translate(-8.61 5.93) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.61 51.48 15.6 51.48 12.62 41.64 23.62 38.31 27.61 51.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.38 31.98 36.98 16.47 23.21 34.27 23.86 36.28 24.15 37.18 36.84 21.12 47.01 36.31 51.43 31.46 53.17 25.72 47.38 31.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.3 14.44 81.26 2.65 79.27 0.8 72.09 8.53 70.3 14.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.15,48.4a2.85,2.85,0,0,1,3-2.85h1.92V44.27a1.81,1.81,0,0,0-1.86-2,1.76,1.76,0,0,0-1.78,1.82c0,.14-.08.2-.2.2h-.73a.19.19,0,0,1-.19-.2,2.85,2.85,0,0,1,2.9-2.9,2.89,2.89,0,0,1,3,3.06V48.4a3,3,0,1,1-6,0Zm4.92,0V46.64h-1.92a1.75,1.75,0,0,0-1.88,1.76,1.82,1.82,0,0,0,1.92,2A1.8,1.8,0,0,0,107.07,48.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.17,51.08V44.31a2.94,2.94,0,1,1,5.88,0v6.77a.19.19,0,0,1-.19.2h-.73a.19.19,0,0,1-.2-.2V44.31a1.83,1.83,0,1,0-3.64,0v6.77a.19.19,0,0,1-.19.2h-.74A.19.19,0,0,1,110.17,51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.89,48.4a2.85,2.85,0,0,1,3-2.85h1.92V44.27a1.81,1.81,0,0,0-1.86-2,1.76,1.76,0,0,0-1.78,1.82c0,.14-.08.2-.19.2h-.73a.19.19,0,0,1-.2-.2,2.85,2.85,0,0,1,2.9-2.9,2.89,2.89,0,0,1,3,3.06V48.4a3,3,0,1,1-6,0Zm4.92,0V46.64h-1.92A1.74,1.74,0,0,0,119,48.4a1.9,1.9,0,1,0,3.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.11,51.08V37.65a.19.19,0,0,1,.19-.2H127a.19.19,0,0,1,.2.2V51.08a.19.19,0,0,1-.2.2h-.73A.19.19,0,0,1,126.11,51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.57,41.6V52.33a2.89,2.89,0,0,1-3,3.1,3,3,0,0,1-3-3.1.19.19,0,0,1,.2-.2h.73a.18.18,0,0,1,.2.2,1.82,1.82,0,0,0,1.88,2,1.78,1.78,0,0,0,1.87-2V50.08a2.36,2.36,0,0,1-1.87,1,2.93,2.93,0,0,1-3-3.1V41.6a.19.19,0,0,1,.2-.2h.73a.19.19,0,0,1,.2.2V48a1.88,1.88,0,1,0,3.75,0V41.6a.19.19,0,0,1,.2-.2h.73A.19.19,0,0,1,135.57,41.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.81,50.43v.69a.19.19,0,0,1-.2.2h-.26c-1.75,0-2.78-1.23-2.78-3.32V42.47h-1.23a.19.19,0,0,1-.19-.2V41.6a.19.19,0,0,1,.19-.2h1.23V38.83a.19.19,0,0,1,.2-.19h.73a.19.19,0,0,1,.2.19V41.4h1.67a.19.19,0,0,1,.2.2v.67a.19.19,0,0,1-.2.2H139.7V48c0,1.46.57,2.23,1.65,2.23h.26A.18.18,0,0,1,141.81,50.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.33,39.35a.73.73,0,0,1,.77-.77.75.75,0,0,1,.77.77.78.78,0,0,1-.77.77A.75.75,0,0,1,143.33,39.35Zm.22,11.73V41.6a.19.19,0,0,1,.19-.2h.74a.19.19,0,0,1,.19.2v9.48a.19.19,0,0,1-.19.2h-.74A.19.19,0,0,1,143.55,51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.69,48.38V44.31a3,3,0,1,1,5.92-.2.19.19,0,0,1-.19.2h-.74a.18.18,0,0,1-.19-.2,1.78,1.78,0,0,0-1.84-1.82,1.82,1.82,0,0,0-1.84,2v4.07a1.83,1.83,0,0,0,1.88,2,1.9,1.9,0,0,0,1.88-2,.18.18,0,0,1,.19-.2h.73a.19.19,0,0,1,.2.2,3,3,0,0,1-3,3.1A2.93,2.93,0,0,1,146.69,48.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.94,48.38a.18.18,0,0,1,.19-.2h.73a.18.18,0,0,1,.2.2,1.84,1.84,0,0,0,2,2c1.18,0,1.77-.65,1.77-1.58,0-2.39-4.84-1.64-4.84-4.94a2.69,2.69,0,0,1,2.85-2.66,2.73,2.73,0,0,1,3,2.9.19.19,0,0,1-.2.2h-.73a.18.18,0,0,1-.19-.2,1.73,1.73,0,0,0-1.8-1.82,1.6,1.6,0,0,0-1.78,1.58c0,2.29,4.84,1.54,4.84,4.94a2.72,2.72,0,0,1-2.9,2.67A3,3,0,0,1,153.94,48.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.44,9.26V28c0,4.14-2.28,6.82-6,6.82a5.08,5.08,0,0,1-4.36-2.31,5,5,0,0,1-4.29,2.31c-3.71,0-6-2.68-6-6.82V9.26a.44.44,0,0,1,.48-.48h2.31a.44.44,0,0,1,.47.48V28.18c0,2.27,1,3.55,2.72,3.55,1.61,0,2.67-1.28,2.67-3.55V9.26A.45.45,0,0,1,91,8.78h2.31a.45.45,0,0,1,.48.48V28.18c0,2.27,1.13,3.55,2.71,3.55,1.76,0,2.68-1.28,2.68-3.55V9.26a.44.44,0,0,1,.47-.48h2.31A.46.46,0,0,1,102.44,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105,28.91c0-3,2.35-5.39,5.8-5.39h2.75v-2a2.54,2.54,0,0,0-2.64-2.78,2.42,2.42,0,0,0-2.5,2.53c0,.33-.18.44-.51.44h-2.13a.47.47,0,0,1-.47-.52,5.49,5.49,0,0,1,5.64-5.46c3.49,0,5.72,2.49,5.72,5.94V29a5.45,5.45,0,0,1-5.72,5.79A5.65,5.65,0,0,1,105,28.91Zm8.55.11V26.34h-2.64a2.53,2.53,0,0,0-2.75,2.57,2.62,2.62,0,0,0,2.75,2.9A2.51,2.51,0,0,0,113.55,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131,9.26V28.87a5.83,5.83,0,1,1-11.66,0V21.69c0-3.49,2.16-6,5.46-6a4.08,4.08,0,0,1,3,1.32V9.26a.45.45,0,0,1,.51-.48h2.12A.46.46,0,0,1,131,9.26Zm-3.15,12.32a2.7,2.7,0,1,0-5.39,0V29a2.7,2.7,0,1,0,5.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.86,16.11a.46.46,0,0,1,.52.48V29c0,1.73,1,2.9,2.56,2.9s2.57-1.17,2.57-2.9V16.59a.46.46,0,0,1,.51-.48h2.13a.46.46,0,0,1,.51.48V28.87c0,3.49-2.31,6-5.72,6s-5.72-2.49-5.72-6V16.59a.46.46,0,0,1,.52-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.34,28.91c0-3,2.35-5.39,5.79-5.39h2.75v-2a2.54,2.54,0,0,0-2.64-2.78,2.41,2.41,0,0,0-2.49,2.53c0,.33-.18.44-.51.44h-2.13a.48.48,0,0,1-.48-.52,5.5,5.5,0,0,1,5.65-5.46c3.48,0,5.72,2.49,5.72,5.94V29a5.45,5.45,0,0,1-5.72,5.79A5.64,5.64,0,0,1,148.34,28.91Zm8.54.11V26.34h-2.64a2.54,2.54,0,0,0-2.75,2.57,2.63,2.63,0,0,0,2.75,2.9A2.51,2.51,0,0,0,156.88,29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnalytics);
export default __webpack_public_path__ + "static/media/logo-analytics.e803b9350199816bce836b96c96c1b9b.svg";
export { ForwardRef as ReactComponent };